import type { TripType } from './types'

/**
 * Default trip type from Project ID (substring match, case-insensitive).
 * Order matters: first match wins.
 *
 * - AR-Partner → Partner
 * - AR-Vol → Volunteer
 * - 26Y → Youth Trip
 * - 26E → Other
 * - 26V → Volunteer
 */
export function inferTripTypeFromProjectId(
  projectId: string | null | undefined
): TripType | null {
  const s = (projectId ?? '').toUpperCase()
  if (!s.trim()) return null
  if (s.includes('AR-PARTNER')) return 'Partner'
  if (s.includes('AR-VOL')) return 'Volunteer'
  if (s.includes('26Y')) return 'Youth Trip'
  if (s.includes('26E')) return 'Other'
  if (s.includes('26V')) return 'Volunteer'
  return null
}
